const SESSION_STORAGE_KEYS = ['user-role', 'user-privileges'];
function getValue(key: string) {
    if (SESSION_STORAGE_KEYS.includes(key)) {
        return sessionStorage.getItem(key) || null;
    }
    return localStorage.getItem(key) || null;
}

function setValue(key: string, value: string) {
    if (SESSION_STORAGE_KEYS.includes(key)) {
        sessionStorage.setItem(key, value);
    } else {
        localStorage.setItem(key, value);
    }
}

function removeValue(keys: string[]) {
    keys.forEach(key => {
        if (SESSION_STORAGE_KEYS.includes(key)) {
            sessionStorage.removeItem(key);
        } else {
            localStorage.removeItem(key);
        }
    });
}

export const Storage = { setValue, getValue, removeValue };